<template>
  <div class="buy_container">
    <back-header :is-white="true" title="活动购买"/>

    <div class="order_title">
      <p>{{ activity.title }}</p>
    </div>

    <div class="order_date_choose">
      <div class="order_line_title">选择时间</div>
      <mt-radio v-if="dateRadios.length" align="left" v-model="postForm.date" :options="dateRadios"/>
      <div v-else class="empty">暂无时间选择</div>
    </div>

    <div class="order_area_choose">
      <div class="order_line_title m_bottom">选择收客地</div>
      <mt-radio v-if="areaRadios.length" align="left" v-model="postForm.area" :options="areaRadios"/>
      <div v-else class="empty">暂无收客地选择</div>
    </div>

    <div v-if="activity.detail_price" class="order_choose_num">
      <div class="order_line_title m_bottom">选择数量</div>
      <price-item
        v-for="(price,index) in activity.detail_price"
        :key="index"
        :num="index?0:1"
        :data="price"
        @numChange="numChange"/>
    </div>

    <buy-footer :price="totalPrice" :canSubmit="canSubmit" @submit="submitForm"/>

  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import backHeader from '@/components/backHeader.vue'
import priceItem from './components/priceItem.vue'
import buyFooter from './components/buyFooter.vue'
import { getActivityDetail } from '@/api/activity'
import { createOrder } from '@/api/order'

export default {
  name: 'activity-buy',
  props: [],
  data () {
    return {
      totalPrice: '0.00',
      totalNum: 0,
      dateRadios: [],
      areaRadios: [],
      postForm: {
        date: '',
        area: '',
        priceData: {}
      },
      activity: {
        id: 0,
        title: ''
      }
    }
  },
  components: {
    backHeader,
    priceItem,
    buyFooter
  },
  computed: {
    canSubmit () {
      let checkRes = this.checkForm()
      return checkRes.status
    }
  },
  created () {
    let id = this.$route.params.id || 0
    if (!id) {
      this.$router.push('/')
      return false
    }
    this.getActivity(id)
  },
  methods: {
    async getActivity (id) {
      let response = await getActivityDetail(id)
      this.activity = response.data
      for (var i = 0; i < this.activity.detail_price.length; i++) {
        let priceItem = this.activity.detail_price[i]
        this.postForm.priceData[priceItem.id] = {
          id: priceItem.id,
          price: priceItem.price,
          num: i ? 0 : 1
        }
      }
      this.getDateRadios()
      this.getAreaRadios()
      this.setTotalPrice()
    },
    getDateRadios () {
      if (!this.activity.detail_date.length) return null

      let dates = this.activity.detail_date
      let data = []
      for (var i = 0; i < dates.length; i++) {
        if (dates[i].expired) continue
        data.push({
          label: dates[i].start_format + ' ~ ' + dates[i].end_format,
          value: dates[i].id + ''
        })
      }
      this.postForm.date = data.length ? data[0].value : null
      this.dateRadios = data
    },
    getAreaRadios () {
      if (!this.activity.area.length) return null

      let areas = this.activity.area
      let data = []
      for (var i = 0; i < areas.length; i++) {
        data.push({
          label: areas[i].name,
          value: areas[i].id + ''
        })
      }
      this.postForm.area = data[0].value
      this.areaRadios = data
    },
    numChange (priceItem, num) {
      this.postForm.priceData[priceItem.id] = {
        id: priceItem.id,
        price: priceItem.price,
        num: num
      }
      this.setTotalPrice()
    },
    setTotalPrice () {
      if (!this.postForm.priceData) return 0
      let totalPrice = 0
      let totalNum = 0
      for (let i in this.postForm.priceData) {
        let priceItem = this.postForm.priceData[i]
        totalPrice += priceItem.price * priceItem.num
        totalNum += priceItem.num
      }
      this.totalPrice = totalPrice.toFixed(2)
      this.totalNum = totalNum
    },
    checkForm () {
      if (this.activity.detail_date && !this.postForm.date) {
        return { status: false, error: '请选择时间' }
      }
      if (this.activity.area && !this.postForm.area) {
        return { status: false, error: '请选择地点' }
      }
      if (!this.totalNum) {
        return { status: false, error: '请选择数量' }
      }
      return { status: true }
    },
    async submitForm () {
      let checkRes = this.checkForm()
      if (!checkRes.status) {
        Toast({ message: checkRes.error, position: 'middle', duration: 3000 })
        return false
      }

      let data = {
        activity: this.activity.id,
        date: parseInt(this.postForm.date),
        area: parseInt(this.postForm.area),
        priceData: []
      }
      for (let i in this.postForm.priceData) {
        data.priceData.push(this.postForm.priceData[i])
      }

      Indicator.open()
      let response = await createOrder(data)
      Indicator.close()

      let order = response.data
      Toast({ message: '提交成功', position: 'middle', duration: 1000 })
      setTimeout(() => {
        this.$router.push('/order/' + order.id + '/confirm')
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .buy_container {
    color: #333;
    margin-bottom: rem(115);
    .order_title {
      background: #ff9500;
      padding: rem(36) rem(18);
      color: #fff;
      p {
        font-weight: bold;
        font-size: rem(28);
      }
      span {
        display: block;
      }
    }
    .order_line_title {
      margin-top: rem(18);
      padding: 0 rem(18);
      font-size: rem(28);
      color: #ff9500;
    }
    .mint-radio-input:checked + .mint-radio-core {
      background-color: #ff9500;
      border-color: #ff9500;
    }
  }
  .empty {
    padding: rem(15) 0 0 rem(20);
  }
</style>
